import { render, staticRenderFns } from "./companyCatalog.vue?vue&type=template&id=7cb8a4a8&scoped=true&"
import script from "./companyCatalog.vue?vue&type=script&lang=js&"
export * from "./companyCatalog.vue?vue&type=script&lang=js&"
import style0 from "./companyCatalog.vue?vue&type=style&index=0&id=7cb8a4a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb8a4a8",
  null
  
)

export default component.exports